<template>
  <section class="c-login">
    <main class="description">
      <section
        class="content"
        v-if="$slots.default"
      >
        <slot />
      </section>
    </main>

    <aside class="form">
      <header class="header">
        <h1 v-if="title">
          {{ title }}
        </h1>
        <p v-if="subtitle">
          {{ subtitle }}
        </p>
      </header>

      <c-form
        class="form"
        @submit="submit"
      >
        <c-input
          :disabled="isSubmitting"
          v-model="email"
          v-validate="'required|email'"
          class="field"
          type="email"
          name="E-mail"
          label="E-mail"
          placeholder="Ex. rodrigo@convenia.com.br"
          :feedback-type="errors.has('E-mail') ? 'error' : null"
          :feedback-message="errors.has('E-mail') ? 'E-mail inválido' : null"
          :feedback-show="errors.has('E-Mail')"
        />
        <c-input
          :disabled="isSubmitting"
          v-model="password"
          v-validate="'required'"
          class="field"
          type="password"
          name="Senha"
          label="Senha"
          placeholder="Ex. ••••••••"
          :feedback-type="errors.has('Senha') ? 'error' : null"
          :feedback-message="errors.has('Senha') ? 'Senha inválida' : null"
          :feedback-show="errors.has('Senha')"
        />
        <c-button
          slot="actions"
          type="submit"
          class="login-button"
          :disabled="isSubmitting"
        >
          <c-spinner
            size="sm"
            v-if="isSubmitting"
          />
          <span v-else>Entrar</span>
        </c-button>
      </c-form>
    </aside>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    isSubmitting: Boolean
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    submit () {
      if (this.$validator.validateAll() && !this.errors.any()) {
        this.$emit('submit', { ...this.$data })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@styles/convenia-components/reference.scss';
@import "~@styles/reference.scss";

.c-login {
  display: flex;
  flex-flow: row nowrap;

  @include mobile {
    justify-content: center;
  }

  &,
  & > .description,
  & > .form {
    min-height: 100vh;
  }
  & > .description {
    flex: 1;
    @extend %login-description;
  }
  & > .form {
    flex: 450px 0 1;
    @extend %login-form;
  }
}

%login-description {
  background-color: $c-color-primary;
  display: flex;
  justify-content: center;
  align-items: center;

  @include mobile {
    display: none;
  }

  & > .content {
    width: 100%;
    padding: calc(#{$spacing} * 4);
    color: white;
  }
}

%login-form {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: $spacing;
  text-align: center;
  padding-bottom: calc(#{$spacing} * 2);
  background-color: white;
  color: $c-color-primary;

  & > .header,
  & > .form {
    flex: 1 0 1;
    padding: $spacing;
    margin-bottom: $spacing;
  }
}

.c-button {
  width: 100%;
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CLogin.vue